import { render, staticRenderFns } from "./login-after-head.vue?vue&type=template&id=2b0767c4&scoped=true&"
import script from "./login-after-head.vue?vue&type=script&lang=js&"
export * from "./login-after-head.vue?vue&type=script&lang=js&"
import style0 from "./login-after-head.vue?vue&type=style&index=0&id=2b0767c4&scoped=scoped&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0767c4",
  null
  
)

export default component.exports